import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import ValueProposition from "./components/ValueProposition";
import Cybersecurity from "./components/Cybersecurity";
import Cloud from "./components/Cloud";
import About from "./components/About";
import WhyChooseUs from "./components/WhyChooseUs";
import Process from "./components/Process";
import FinalCTA from "./components/FinalCTA";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <ValueProposition />
        <Cybersecurity />
        <Cloud />
        <About />
        <WhyChooseUs />
        <Process />
        <FinalCTA />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}